import Section from "../components/Section";
export default function NotFound() {
  return (
    <Section title="Page not found">
      <a className="text-rose-700" href="/">Go Home →</a>
    </Section>
  );
}
